export default __webpack_public_path__ + "static/media/menu-sidebar.16104111.svg";